import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bac5503"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"margin":"0"}
}
const _hoisted_2 = {
  key: 1,
  style: {"margin":"0"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "新增章节" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "课程",
            rules: _ctx.rules.title
          }, {
            default: _withCtx(() => [
              (_ctx.courseName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.courseName), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_a_divider, { type: "vertical" }),
              (_ctx.typeName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.typeName), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            ref: "title",
            label: "章节名称",
            name: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.title,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.title) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          (_ctx.formState.media_type === 1)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                ref: "media_url",
                label: "视频",
                name: "media_url",
                placeholder: "请输入",
                extra: "可以输入视频网络地址或上传视频",
                rules: [{required: true, message: '请上传文件'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.media_url,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.media_url) = $event)),
                    class: _normalizeClass({'form_hide': _ctx.formState.media_type === 0}),
                    style: {"margin-bottom":"10px"}
                  }, null, 8, ["value", "class"]),
                  _createVNode(_component_a_form_item_rest, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_UploadComponent, {
                        "on-change": _ctx.onMediaChange,
                        "source-url": _ctx.formState.media_url,
                        type: "video"
                      }, null, 8, ["on-change", "source-url"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          (_ctx.formState.media_type === 2)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 1,
                ref: "media_url",
                label: "视频",
                name: "media_url",
                placeholder: "请输入",
                extra: "可以输入音频网络地址或上传音频",
                rules: [{required: true, message: '请上传文件'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.media_url,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.media_url) = $event)),
                    class: _normalizeClass({'form_hide': _ctx.formState.media_type === 0}),
                    style: {"margin-bottom":"10px"}
                  }, null, 8, ["value", "class"]),
                  _createVNode(_component_a_form_item_rest, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_UploadComponent, {
                        "on-change": _ctx.onMediaChange,
                        "source-url": _ctx.formState.media_url,
                        type: "audio"
                      }, null, 8, ["on-change", "source-url"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          ([1,2].includes(_ctx.formState.media_type))
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 2,
                ref: "duration",
                label: "时长",
                name: "duration",
                extra: "超过1小时格式：01:30:30；不到1小时格式：45:12；不到1分钟格式：00:12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.duration,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.duration) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, {
            ref: "sort",
            label: "排序",
            name: "sort"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.sort,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.sort) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "content",
            label: "内容",
            name: "content",
            placeholder: "请输入"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.content,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.content) = $event)),
                class: "form_hide"
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_EditorComponent, {
                    ref: "editorComponentRef",
                    content: _ctx.formState.content
                  }, null, 8, ["content"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            "wrapper-col": { span: 14, offset: 4 },
            style: {"margin-top":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSubmit,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: _ctx.goBack,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "label-col", "wrapper-col"])
    ]),
    _: 1
  }))
}